import React from 'react';
import { atom, useAtom, useAtomValue } from '@exodus/headless-ui';
import Select from '../select/index.js';
import { fromAssetAtom, fromAssetsAtom, fromWalletAccountAtom } from '../../../atoms/index.js';
const fromWalletAccountsAtom = atom((get, { selectors }) => {
    const asset = get(fromAssetAtom);
    const getWalletAccount = get(selectors.walletAccounts.get);
    const enabledWalletAccounts = get(selectors.walletAccounts.enabled);
    const assetNamesByWalletAccount = get(selectors.assetSources.availableAssetNamesByWalletAccount);
    return enabledWalletAccounts
        .filter((walletAccount) => assetNamesByWalletAccount[walletAccount]?.has(asset.name))
        .map(getWalletAccount);
});
const FromSelect = ({ Component, onSelect, ...rest }) => {
    const fromAssets = useAtomValue(fromAssetsAtom);
    const fromWalletAccounts = useAtomValue(fromWalletAccountsAtom);
    const [fromWalletAccount, setFromWalletAccount] = useAtom(fromWalletAccountAtom);
    return (React.createElement(Select, { side: "from", Component: Component, assets: fromAssets, walletAccount: fromWalletAccount, walletAccounts: fromWalletAccounts, loading: false, onSelect: onSelect, onWalletAccountChange: setFromWalletAccount, ...rest }));
};
export default FromSelect;
